import { css } from "styled-components";

export const HOME_PAGE_SIDE_PADDING = 28;
export const HOME_PAGE_SIDE_PADDING_MEDIUM = 24;
export const HOME_PAGE_SIDE_PADDING_SMALL = 16;

export const homePageTopPaddingStyles = css`
  padding-top: ${HOME_PAGE_SIDE_PADDING}px;

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.MEDIUM}px`}) {
    padding-top: ${HOME_PAGE_SIDE_PADDING_MEDIUM}px;
  }

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.SMALL}px`}) {
    padding-top: ${HOME_PAGE_SIDE_PADDING_SMALL}px;
  }
`;

export const homePageBottomPaddingStyles = css`
  padding-bottom: ${HOME_PAGE_SIDE_PADDING}px;

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.MEDIUM}px`}) {
    padding-bottom: ${HOME_PAGE_SIDE_PADDING_MEDIUM}px;
  }

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.SMALL}px`}) {
    padding-bottom: ${HOME_PAGE_SIDE_PADDING_SMALL}px;
  }
`;

export const homePageLeftPaddingStyles = css`
  padding-left: ${HOME_PAGE_SIDE_PADDING}px;

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.MEDIUM}px`}) {
    padding-left: ${HOME_PAGE_SIDE_PADDING_MEDIUM}px;
  }

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.SMALL}px`}) {
    padding-left: ${HOME_PAGE_SIDE_PADDING_SMALL}px;
  }
`;

export const homePageRightPaddingStyles = css`
  padding-right: ${HOME_PAGE_SIDE_PADDING}px;

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.MEDIUM}px`}) {
    padding-right: ${HOME_PAGE_SIDE_PADDING_MEDIUM}px;
  }

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.SMALL}px`}) {
    padding-right: ${HOME_PAGE_SIDE_PADDING_SMALL}px;
  }
`;

export const homePageHorizontalPaddingStyles = css`
  ${homePageLeftPaddingStyles}
  ${homePageRightPaddingStyles}
`;

export const homePagePaddingStyles = css`
  padding: ${HOME_PAGE_SIDE_PADDING}px;

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.MEDIUM}px`}) {
    padding: ${HOME_PAGE_SIDE_PADDING_MEDIUM}px;
  }

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.SMALL}px`}) {
    padding: ${HOME_PAGE_SIDE_PADDING_SMALL}px;
  }
`;
